module.exports = __webpack_public_path__ + "media/9c_ASANBUDAPEST-BASS09c.cdd5d3a4.mp3";